<template>
  <div class="row top-menu">
    <div class="col-2 col-vertical-center">
      <CLogo
        :svgPath="svgPath"
        :svgWidth="svgWidth"
        :svgMargin="svgMargin"
      ></CLogo>
    </div>
    <div class="col-7">
      <nav class="navbar navbar-expand-lg navbar-dark bg-dark">
        <ul class="navbar-nav mr-auto">
          <CMenuItem
            v-for="menu in menuList" :key="menu.id"
            :id="menu.id"
            :label="menu.label"
            :isActive="renderLinkIsActive(menu.id)"
          ></CMenuItem>
        </ul>

      </nav>
    </div>
    <div class="col-3">
      <!-- <CAccount
        :user="user"
      ></CAccount> -->
    </div>
  </div>
</template>

<script>
import CLogo from "@/lib/tui/components/menu/CLogo.vue";
import CMenuItem from "@/lib/tui/components/menu/CMenuItem.vue";
// import CAccount from "@/lib/tui/components/menu/CAccount.vue";
export default {
  name: "CTopMenu",
  //////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////
  components: {
    CMenuItem,
    CLogo,
    // CAccount
  },
  //////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////
  props: {
    menuList: Array,
    svgPath: String,
    user: Object,
    svgWidth: {
      type: String,
      default: "5vw"
    },
    svgMargin: {
      type: String,
      default: "0 0 0.5vh 0"
    }
  },
  //////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////
  data () {
    return {
      currentRouteName: ""
    }
  },
  //////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////
  methods: {
    renderLinkIsActive: function(id) {
      let status = id === this.currentRouteName ? true : false; 

      if (!status && Object.prototype.hasOwnProperty.call(this.$route.meta, "parent")) {
        if (this.$route.meta.parent === id)
          status = true;
      }

      return status;
    }
  },
  //////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////
  watch: {
    $route: function(newVal) {
      this.currentRouteName = newVal.name;
    }
  }
}
</script>

<style lang="scss" scoped>
  .bg-dark {
    background: none !important;
  }

  .top-menu {
    padding: 0;
    margin: 0;
    height: 6vh;
    width: 100%;
    color: $textDefault;
    background: linear-gradient(180deg, #444d5c, #13161b);
    box-shadow: 0px 4px 25px $blackTrue;
    border-bottom: 1px solid $gray;
    z-index: 101;
  }

  // .col-vertical-center {
  //   display: flex;
  //   justify-content: center;
  //   flex-direction: column;
  // }
</style>